/**
 * Error message extraction utility
 */
export const getErrorMessage = (error: Error | any, defaultMessage: string) => {
  return (
    error.response?.data?.message ??
    error?.response?.data?.error ??
    error.message ??
    defaultMessage
  );
};


export function getAxiosErrorMessage(error: unknown): string {
  const axiosError = error as {
    response?: {
      data?: { message?: string; error?: string };
    };
    message?: string;
  };

  if (axiosError.response?.data?.message) {
    return axiosError.response.data.message;
  }

  if (axiosError.response?.data?.error) {
    return axiosError.response.data.error;
  }

  if (axiosError.message) {
    return axiosError.message;
  }

  return "An error occurred while processing your request";
}

export function getSolanaErrorMessage(error: unknown): string {
  const solanaError = error as { message?: string };
  // Handle Solana-specific errors
  if (solanaError?.message) {
    // Parse common Solana error patterns
    if (solanaError.message.includes("User rejected")) {
      return "Transaction was rejected";
    }
    if (solanaError.message.includes("insufficient funds")) {
      return "Insufficient SOL for transaction";
    }
    if (solanaError.message.includes("Allocation already claimed")) {
      return "You have already claimed your NFT";
    }
    if (solanaError.message.includes("No allocation")) {
      return "You don't have an allocation for this phase";
    }
    if (solanaError.message.includes("Phase not active")) {
      return "This minting phase is not currently active";
    }
    return solanaError.message;
  }

  return "A Solana transaction error occurred";
}
